module.exports = __webpack_public_path__ + "img/calendar.ef32533a.svg";